import React from 'react';
import { ContractDetails, Contract } from '@cp-mx/common';
import { FinancialDetails } from '../financial-details';
import { VehicleDetails } from '../vehicle-details';
import { Accordion, AccordionItem } from '@cp-shared-19/frontend-ui';
import { InsuranceDetails } from '../insurance-details';
import { AdditionalServicesDetails } from '../additional-services-details';

export const ContractDetailsUi: React.FC<{ contract?: Contract; contractDetails?: ContractDetails }> = ({
    contract,
    contractDetails,
}) => {
    if (!contractDetails || !contract) {
        return null;
    }

    return (
        <Accordion openOneAtTime={false}>
            <div className={'u-mt-small u-mb-small'}></div>
            <AccordionItem title={contractDetails.headlineFinancialDetails}>
                <FinancialDetails contract={contract} />
            </AccordionItem>
            <AccordionItem title={contractDetails.headlineVehicleDetails}>
                <VehicleDetails contract={contract} />
            </AccordionItem>
            <InsuranceDetails contract={contract} title={contractDetails.headlineInsuranceDetails} />
            <AdditionalServicesDetails contract={contract} title={contractDetails.headlineAdditionalServicesDetails} />
        </Accordion>
    );
};
